module.exports = __webpack_public_path__ + "img/step-12.0610a95d.jpg";